import { colors } from '@constant/colors';
import styled from 'styled-components';

export const ErrorMsg = styled.div`
  color: ${colors.SYSTEM_ERROR};
  font-weight: bold;
`;
